'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _dec, _class; // Lib


// Utils


// Selectors


// Constants


var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = require('react-redux');

var _milanoteReselect = require('../milanoteReselect/milanoteReselect');

var _userService = require('../../user/userService');

var _sharingUtilSelector = require('../../workspace/header/utils/sharing/sharingUtilSelector');

var _remoteUsersSelector = require('./remoteUsersSelector');

var _socketConnectionSelector = require('../socket/socketConnectionSelector');

var _currentUserSelector = require('../../user/currentUserSelector');

var _userConstants = require('../../../common/users/userConstants');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var mapStateToProps = (0, _milanoteReselect.createShallowSelector)(_sharingUtilSelector.remoteUserIdsCurrentlyViewingSelector, _remoteUsersSelector.getTrackedUserIds, _socketConnectionSelector.socketConnectedSelector, _currentUserSelector.isGuestSelector, function (remoteUserIdsCurrentlyViewing, remoteUserIds, socketConnected, isGuest) {
    return {
        remoteUserIdsCurrentlyViewing: remoteUserIdsCurrentlyViewing,
        remoteUserIds: remoteUserIds,
        socketConnected: socketConnected,
        isGuest: isGuest
    };
});

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
    return {
        dispatchFetchUserActivity: function dispatchFetchUserActivity(userIds) {
            return dispatch((0, _userService.fetchUserActivity)(userIds));
        },
        dispatchCheckIdleUsers: function dispatchCheckIdleUsers() {
            return dispatch((0, _userService.checkIdleUsers)());
        }
    };
};

var UserActivityManager = (_dec = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps), _dec(_class = function (_React$Component) {
    _inherits(UserActivityManager, _React$Component);

    function UserActivityManager() {
        _classCallCheck(this, UserActivityManager);

        return _possibleConstructorReturn(this, (UserActivityManager.__proto__ || Object.getPrototypeOf(UserActivityManager)).apply(this, arguments));
    }

    _createClass(UserActivityManager, [{
        key: 'componentWillMount',
        value: function componentWillMount() {
            // Check for idle users twice for every timeout interval.  That way the client can only be at most
            // 1/2 a timeout out of sync.  For example if the timeout is 10 minutes the client will be updated
            // of another user's disconnection within at least 5 minutes.
            this.idleUserCheckIntervalId = setInterval(this.props.dispatchCheckIdleUsers, _userConstants.USER_IDLE_TIMEOUT_MILLISECONDS / 2);
        }
    }, {
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(nextProps) {
            var currentBoardId = nextProps.currentBoardId,
                remoteUserIdsCurrentlyViewing = nextProps.remoteUserIdsCurrentlyViewing,
                dispatchFetchUserActivity = nextProps.dispatchFetchUserActivity,
                socketConnected = nextProps.socketConnected,
                remoteUserIds = nextProps.remoteUserIds,
                isGuest = nextProps.isGuest;

            // Don't load any user activity for guest users

            if (isGuest) return;

            // When we navigate to a new board that has remote users on it, get updates for their user activity
            if (currentBoardId !== this.props.currentBoardId && remoteUserIdsCurrentlyViewing.length) {
                dispatchFetchUserActivity(remoteUserIdsCurrentlyViewing);
            }

            // If we become connected again, re-fetch every user's activity
            if (socketConnected && !this.props.socketConnected && remoteUserIds.length) {
                dispatchFetchUserActivity(remoteUserIds);
            }
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            if (this.idleUserCheckIntervalId) clearInterval(this.idleUserCheckIntervalId);
        }
    }, {
        key: 'render',
        value: function render() {
            return _react2.default.Children.only(this.props.children);
        }
    }]);

    return UserActivityManager;
}(_react2.default.Component)) || _class);


UserActivityManager.propTypes = {
    children: _propTypes2.default.element.isRequired,
    remoteUserIdsCurrentlyViewing: _propTypes2.default.array,
    remoteUserIds: _propTypes2.default.array,
    currentBoardId: _propTypes2.default.string,
    dispatchFetchUserActivity: _propTypes2.default.func,
    dispatchCheckIdleUsers: _propTypes2.default.func,
    isGuest: _propTypes2.default.bool,
    socketConnected: _propTypes2.default.bool
};

exports.default = UserActivityManager;


//////////////////
// WEBPACK FOOTER
// ./src/client/utils/collaboration/UserActivityManager.js
// module id = 2119
// module chunks = 0